import TimelineContainer from "../../components/bonusUi/timeline";

const TimeLine = () => {
  return <TimelineContainer />;
};

export default TimeLine;
